import { createStore } from 'vuex'
import axios from 'axios'

let userLanguage = window.navigator.userLanguage || window.navigator.language;
userLanguage.includes("nl") ? userLanguage = "nl" : userLanguage = "en";

const urlString = window.location.href
const url = new URL(urlString);
const currLang = url.searchParams.get("lang");

const lang = currLang ? currLang : userLanguage;
// console.log("taal: ", lang);

export default createStore({
	state: {
		content: [],
		router: null,
		language: lang
	},
	mutations: {
		SAVE_CONTENT (state, data) {
			state.content = data.data;
		}, 

		switchLanguage (state) {
			const urlString = window.location.href
			const url = new URL(urlString);
			const params = new URLSearchParams(url.search);

			if (state.language === "nl") {
				//update url query
				params.set("lang", "en");

				//set content language
				state.language = "en"
			}
			else {
				//update url query
				params.set("lang", "nl");

				//set content language
				state.language = "nl"
			}

			var newUrl = window.location.origin 
				+ window.location.pathname 
				+ '?' + params.toString();
			window.history.pushState({path:newUrl},'', newUrl);
		}
	},
	getters: {
		articleItems: state => state.articles
	},
	actions: {
		loadContent ({commit, state}) {
			return new Promise((resolve, reject) => { 
				axios
					.get(process.env.VUE_APP_API)
					.then(result => {
						commit("SAVE_CONTENT", result.data);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			});
		}
	},
	modules: {

	}
})
